
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'avgitemprice'
    })
  } // computed
}; // export default
